var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 0.166504C1.22464 0.166504 0.800716 0.342099 0.488155 0.654659C0.175595 0.96722 0 1.39114 0 1.83317V10.1665C0 10.6085 0.175595 11.0325 0.488155 11.345C0.800716 11.6576 1.22464 11.8332 1.66667 11.8332C2.10869 11.8332 2.53262 11.6576 2.84518 11.345C3.15774 11.0325 3.33333 10.6085 3.33333 10.1665V1.83317C3.33333 1.39114 3.15774 0.96722 2.84518 0.654659C2.53262 0.342099 2.10869 0.166504 1.66667 0.166504ZM8.33333 0.166504C7.89131 0.166504 7.46738 0.342099 7.15482 0.654659C6.84226 0.96722 6.66667 1.39114 6.66667 1.83317V10.1665C6.66667 10.6085 6.84226 11.0325 7.15482 11.345C7.46738 11.6576 7.89131 11.8332 8.33333 11.8332C8.77536 11.8332 9.19928 11.6576 9.51184 11.345C9.8244 11.0325 10 10.6085 10 10.1665V1.83317C10 1.39114 9.8244 0.96722 9.51184 0.654659C9.19928 0.342099 8.77536 0.166504 8.33333 0.166504Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.d34f592dc8db4c93e2f727b7150c22af.svg";
export { ForwardRef as ReactComponent };